
const getSlimVariations = (commonCanopies, commonVariaton) => {

	return {
		'0920': {
			...commonVariaton,
			size: {
				width: 0.026,
				height: 1,
				depth: 0.026
			},
			paddingTop: -1,
			familyName: 'slim',
			related: ['0920'],
			canopy: {
				...commonCanopies,
				"10": {
					...commonCanopies['10'],
					source: '/models/canopy_skan.glb',
					size: {
						width: 0.16,
						depth: 0.16,
						height: 0.033
					}
				}
			},
			light: {
				type: 'spot',
				power: 199,
				options: { angle: Math.PI / 8 }
			}
		}
	}
}

export default getSlimVariations